import {BaseDto} from '../../../../common/src/lib/dtos/base.dto';

/**
 * Note the field name: the Nookal endpoint expects accountCode, while the
 * Cliniko and Model Health endpoints expect userCode.
 */
export class NookalPrepareIntegrationRequestDto extends BaseDto {
    accountCode: string;

    public deserialize(input: any): this {
        Object.assign(this, input);
        return this;
    }

    constructor(accountCode: string) {
        super();
        this.accountCode = accountCode;
    }
}
